<template>
  <v-app class="ma-0 pa-0" id="app">
    <v-stepper alt-labels class="elevation-0" v-model="e1">
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-stepper-header class="elevation-0 ma-5">
            <v-stepper-step :complete="e1 > 1" step="1">Profil</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 2" step="2">Allgemeines</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">Tätigkeitsbereich</v-stepper-step>
          </v-stepper-header>
        </v-flex>
      </v-layout>

      <v-stepper-items>
        <!------ STEP 1 ------->
        <v-stepper-content step="1">
          <v-container fluid fill-height>
            <v-layout align-center justify-center>
              <v-flex xs12 sm8 md4>
                <v-card class="elevation-9">
                  <v-toolbar color="primary" light flat>
                    <v-toolbar-title class="white--text">Schritt 1:</v-toolbar-title>
                  </v-toolbar>
                  <ImageUploaderComplete v-model="formInput.image" />
                  <span v-if="formInput.image.length < 4">Bitte laden Sie ein Bild hoch.</span>
                  <v-card-text>
                    <v-form class="pa-8">
                      <!--v-text-field
                        v-model="formInput.name"
                        label="Name"
                        name="Name"
                         :error-messages="nameErrors"
                        prepend-icon="mdi-account"
                        type="text"
                      ></v-text-field-->

                      <v-text-field
                        v-model="formInput.email"
                        label="Alternative Email"
                        name="Email"
                         :error-messages="emailErrors"
                        prepend-icon="mdi-email"
                        type="email"
                      ></v-text-field>


                </v-form>
              </v-card-text>
              <v-card-actions class="px-12 py-8">
              
                
  
          
          <v-spacer></v-spacer>
          <v-btn 
            color="accent"
            @click="submit1()">
            Weiter
          </v-btn>
              </v-card-actions >
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
  
          
        </v-stepper-content>
  

  <!------ STEP 2 ------->  
         <v-stepper-content step="2">  
          <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
          >
            <v-card class="elevation-9">
              <v-toolbar
                color="primary"
                light
                flat
              >
                <v-toolbar-title class="white--text">Schritt 2</v-toolbar-title>
                
              </v-toolbar>
              
              <v-card-text>
                
                <v-form class="pa-8" ref="step2">
                  <!--v-text-field
                    v-model="formInput.competence_center"
                    label="Kompetenzzentrum"
                     :error-messages="compentenceErrors"
                    name="Kompetenzzentrum"
                    prepend-icon="mdi-city"
                    type="text"
                  ></v-text-field-->

                 <v-autocomplete
                          v-model="formInput.competence_center"
                  :items="cocs"
                  item-text="name"
                  label="Kompetenzzentrum"
                  prepend-icon="mdi-city"
                ></v-autocomplete>
                  
                  

                  <v-text-field
                    v-model="formInput.street"
                    label="Straße und Hausnummer"
                    name="Straße und Hausnummer"
                     :error-messages="streetErrors"
                    prepend-icon="mdi-map-marker"
                    type="text"
                  ></v-text-field>
                  
                    <v-layout row>
                    <v-flex ml-11 mr-3>

                    <v-text-field
                    v-model="formInput.zip"
                    label="Postleitzahl"
                    name="Postleitzahl"
                     :error-messages="zipErrors"
                    prepend-icon=""
                    type="text"
                  ></v-text-field>
                  </v-flex>
                  </v-layout>
<v-layout row>
                    <v-flex ml-11 mr-3>
                    <v-text-field
                    v-model="formInput.city"
                    label="Stadt"
                    name="Stadt"
                     :error-messages="cityErrors"
                    prepend-icon=""
                    type="text"
                  ></v-text-field>
                    </v-flex></v-layout>
                  
                  <v-text-field
                    v-model="formInput.phone_number"
                    label="Telefon"
                    name="Telefon"
                     :error-messages="phoneErrors"
                    prepend-icon="mdi-phone"
                    type="text"
                  ></v-text-field>

                  <v-text-field
                    v-model="formInput.web"
                    label="Web"
                    name="Web"
                     :error-messages="webErrors"
                    prepend-icon="mdi-web"
                    type="text"
                  ></v-text-field>

                </v-form>
              </v-card-text>
              <v-card-actions  class="px-12 py-8">
          <v-btn @click="e1 = 1" text>Zurück</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-bind:disabled="formInput.competence_center.length < 4 || formInput.street.length < 4 || formInput.zip.length < 4 || formInput.phone_number.length < 4 || formInput.web.length < 4 || formInput.city.length < 4 "
            color="accent"
            @click="submit2()">
            Weiter
          </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
  
          
        </v-stepper-content>
  

  <!------ STEP 3 ------->  

          <v-stepper-content step="3">  
          <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md6
          >
            <v-card class="elevation-9">
              <v-toolbar
                color="primary"
                light
                flat
              >
                <v-toolbar-title class="white--text">Schritt 3</v-toolbar-title>
                
              </v-toolbar>
              
              <v-card-text>

                 <!------ Schwerpunkte -------------------
                <h2 class="mt-6 mb-0 text-left">Schwerpunkte</h2>
                <Schwerpunkte v-bind:schwerpunkte="schwerpunkte" v-bind:schwerpunktElements="schwerpunktElements"/>
                 ------->  
                 <h2 class="my-6 text-left">Schwerpunkte</h2>
                 <v-autocomplete
                v-model="formInput.main_emphases"
                :disabled="isUpdating"
                :items="schwerpunktElements"
                filled
                chips
                color="blue-grey lighten-2"
                label="Aus vorhandenen Schwerpunkten auswählen"
                item-text="name"
                item-value="name"
                multiple
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected.name"
                    close
                    @click="data.select"
                    @click:close="removeSchwerpunkt(data.item)"
                  >
                   
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
               <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Neuen Schwerpunkt anlegen</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Anlegen eines Schwerpunktes</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="newEmphasis" label="Schwerpunkt" required></v-text-field>
              </v-col>
            </v-row>
          </v-container>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Abbrechen</v-btn>
          <v-btn v-bind:disabled="buttonDisabled" class="primary" text @click="addEmphasis()">Anlegen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>


                  <!------ Branche -----------------------
                <h2 class="mt-6 mb-0 text-left">Spezialisierte Branche</h2>
                <Schwerpunkte v-bind:schwerpunkte="formInput.main_emphases" v-bind:schwerpunktElements="schwerpunktElements"/>
                 ------->  

                 <h2 class="my-6 text-left">Spezialisierte Branche</h2>

                <v-autocomplete
                v-model="formInput.industry_sectors"
                :disabled="isUpdating"
                :items="brancheElements"
                filled
                chips
                color="blue-grey lighten-2"
                label="Aus vorhandenen Branchen auswählen"
                item-text="name"
                item-value="name"
                multiple
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected.name"
                    close
                    @click="data.select"
                    @click:close="removeSector(data.item)"
                  >
                   
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>


              <!------ Technologien ------->  
               <h2 class="my-6 text-left">Technologien</h2>
               <h4>Optional. Diese Technologien sind nicht KI-spezifisch und werden auch nicht im Profil angezeigt.</h4>
              <v-autocomplete
                v-model="formInput.technologies"
                :disabled="isUpdating"
                :items="techElements"
                filled
                chips
                color="blue-grey lighten-2"
                label="Aus vorhandenen Technologien auswählen"
                item-text="name"
                item-value="hash"
                multiple
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected.hash"
                    close
                    @click="data.select"
                    @click:close="removeTech(data.item)"
                  >
                   
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>                
              </v-card-text>
              <v-card-actions class="px-12 py-8">
                    <v-btn @click="e1 = 2" text>Zurück</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="accent" 
                     v-bind:disabled="sending"
                    @click="sendForm" >
                    Speichern</v-btn>
                  </v-card-actions>
            <v-progress-linear v-if="sending"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
  
          
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
   
  </v-app>
</template>


<script>
import ImageUploaderComplete from "../components/ImageUploaderComplete";
//import SchwerpunktSelector from '../components/Schwerpunkt-selector.vue';
import {getKITrainer, postKITrainer, getMainEmphases, getIndustrySectors, getTechnologies, postEmphasis} from '../api';
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'


export default {
    name: "Form",
    mixins: [validationMixin],

    validations: {
      formInput:{ 
            street: { required, minLength: minLength(4) },
            zip: { required}, 
            city: { required},
            competence_center: { required},
            phone_number: { required},
            email:{email },
            web: { required}},
    },
    data() {
        return {    
    // Selector
          autoUpdate: true,
          isUpdating: false,
          formInput:{ 
            name: '', 
            image: '',
            street: '',
            zip: '', 
            city: '',
            competence_center: '',
            phone_number: '',
            email:'',
            web: '',
            main_emphases: [],
            industry_sectors: [],
            technologies: [],
          },
          buttonDisabled:false,
          sending:false,
          dialog: false,
          newEmphasis:'',
          cocs:[
            "Mittelstand-Digital Zentrum Augsburg",
            "Mittelstand-Digital Zentrum Bau",
            "Mittelstand-Digital Zentrum Berlin",
            "Mittelstand-Digital Zentrum Bremen-Oldenburg",
            "Mittelstand-Digital Zentrum Chemnitz",
            "Mittelstand-Digital Zentrum Darmstadt",
            "Mittelstand-Digital Zentrum Fokus Mensch",
            "Mittelstand-Digital Zentrum Franken",
            "Mittelstand-Digital Zentrum Hamburg",
            "Mittelstand-Digital Zentrum Handwerk",
            "Mittelstand-Digital Zentrum Hannover",
            "Mittelstand-Digital Zentrum Ilmenau",
            "Mittelstand-Digital Zentrum Kaiserslautern",
            "Mittelstand-Digital Zentrum Klima.Neutral.Digital",
            "Mittelstand-Digital Zentrum Ländliche Regionen",
            "Mittelstand-Digital Zentrum Leipzig-Halle",
            "Mittelstand-Digital Zentrum Lingen.Münster.Osnabrück",
            "Mittelstand-Digital Zentrum Magdeburg",
            "Mittelstand-Digital Zentrum Rheinland",
            "Mittelstand-Digital Zentrum Rostock",
            "Mittelstand-Digital Zentrum Ruhr-OWL",
            "Mittelstand-Digital Zentrum Saarbrücken",
            "Mittelstand-Digital Zentrum Schleswig-Holstein",
            "Mittelstand-Digital Zentrum Smarte Kreisläufe",
            "Mittelstand-Digital Zentrum Spreeland",
            "Mittelstand-Digital Zentrum Tourismus",
            "Mittelstand-Digital Zentrum WertNetzWerke",
            "Mittelstand-Digital Zentrum Zukunftskultur",
          ],
          schwerpunktElements: [],
          brancheElements: [],
          techElements: [],    
          e1: 1,
    };
  },

  
     computed: {
      emailErrors () {
        const errors = []
        if (!this.$v.formInput.email.$dirty) return errors
        !this.$v.formInput.email.email && errors.push('Keine gültige Email-Adresse')
        //!this.$v.formInput.email.required && errors.push('Email ist ein Pflichfeld')
        return errors
      },
      streetErrors () {
        const errors = []
        if (!this.$v.formInput.street.$dirty) return errors
        !this.$v.formInput.street.required && errors.push('Straße und Hausnummer ist ein Pflichfeld')
        return errors
      },
      zipErrors () {
        const errors = []
        if (!this.$v.formInput.zip.$dirty) return errors
        !this.$v.formInput.zip.required && errors.push('Postleitzahl ist ein Pflichfeld')
        return errors
      },
      cityErrors () {
        const errors = []
        if (!this.$v.formInput.city.$dirty) return errors
        !this.$v.formInput.city.required && errors.push('Stadt ist ein Pflichfeld')
        return errors
      },
      webErrors () {
        const errors = []
        if (!this.$v.formInput.web.$dirty) return errors
        !this.$v.formInput.web.required && errors.push('Webseite ist ein Pflichfeld')
        return errors
      },
      phoneErrors () {
        const errors = []
        if (!this.$v.formInput.phone_number.$dirty) return errors
        !this.$v.formInput.phone_number.required && errors.push('Telefonnummer ist ein Pflichfeld')
        return errors
      },
      compentenceErrors () {
        const errors = []
        if (!this.$v.formInput.competence_center.$dirty) return errors
        !this.$v.formInput.competence_center.required && errors.push('Kompetenzzentrum ist ein Pflichfeld')
        return errors
      }
    },
    methods: {
      addEmphasis(){
        this.buttonDisabled=true;
          postEmphasis({name:this.newEmphasis,hash:""}).then(res=>{
            this.schwerpunktElements.push(res)
            this.formInput.main_emphases.push(this.newEmphasis);
            this.buttonDisabled=false;
            this.dialog=false;
             this.newEmphasis=''
          })
      },
      submit1 () {
         this.e1 = 2
         this.$v.formInput.email.$touch()
      },
      submit2 () {
         this.$v.formInput.street.$touch()
         this.$v.formInput.zip.$touch()
         this.$v.formInput.web.$touch()
         this.$v.formInput.city.$touch()
         this.$v.formInput.competence_center.$touch()
         this.$v.formInput.phone_number.$touch()
        if(!(this.$v.formInput.street.$invalid||this.$v.formInput.zip.$invalid||this.$v.formInput.web.$invalid||this.$v.formInput.city.$invalid||this.$v.formInput.competence_center.$invalid||this.$v.formInput.phone_number.$invalid)){
            this.e1 = 3
        }
      },
      sendForm:function()
      {
        this.sending=true;
        //alert(this.formInput.image)
        console.log("form-----");
        postKITrainer(this.formInput).then(res=>{
          this.sending=false;
          this.$router.push({name: "success"});
        })
      },
      removeSchwerpunkt (item) {
      const index = this.formInput.main_emphases.indexOf(item.name)
      if (index >= 0) this.formInput.main_emphases.splice(index, 1)},

      removeSector (item) {
      const index = this.formInput.industry_sectors.indexOf(item.name)
      if (index >= 0) this.formInput.industry_sectors.splice(index, 1)},

      removeTech (item) {
      const index = this.formInput.technologies.indexOf(item.hash)
      if (index >= 0) this.formInput.technologies.splice(index, 1)},

      
      },

  components: {
    ImageUploaderComplete: ImageUploaderComplete
    //Schwerpunkte: SchwerpunktSelector,
  },

  //Selector Step 3

  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000);
      }
    }
  },
 created(){
   getKITrainer()
    .then(res=>{
     console.log("res: "+res)
     if(res){
          this.$router.push({name: "profile"});
     } else {
       console.log("no profile")
     }
      getTechnologies().then(res=>{
        this.techElements=res;
        this.techElements.sort(function(a, b) {
        var textA = a.name.toUpperCase();
        var textB = b.name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });
   })
   getMainEmphases().then(res=>{
     this.schwerpunktElements=res;
     console.log(this.schwerpunktElements);
   })
   getIndustrySectors().then(res=>{
     this.brancheElements=res;
     console.log(this.brancheElements);
   })  
   })
 },

}


</script>


<style scoped>
.v-content {
  padding: 0px !important;
}
</style>





